<template>
   <TermsCondition
      v-if="termsConditionModal && isSubscriptionModelActivated()"
      :visible="false"
      @terms-condition:accepted="handleAcceptCondition"
   />

   <SubscriptionModal
      v-if="showSubscriptionModal && isSubscriptionModelActivated() && !isSubscribe && !termsConditionModal"
      :visible="subscriptionCloseButton"
      @subscribe:premium-plan="handleSubscribeToPremiumPlan"
      @select:free-plan="handleSelectFreePlan"
      @modal:close="showSubscriptionModal = false"
   />

   <ConfirmationFreePlanModal
      v-if="confirmationFreePlanModal && isSubscriptionModelActivated() && !isSubscribe"
      :visible="false"
      @goback="handleGoBack"
      @decline:offer="handleSubscribeToFreePlan"
   />
</template>

<script setup>
import { isSubscriptionModelActivated } from "../../utils/helpers";
import { onMounted, ref } from "vue";
import { applyFreeFeatures } from "../../api/profile";
import {storeToRefs} from "pinia";
import { useSubscriptionPlanStore } from "../../store/subscription.store";
import { useFeatureUsageStore } from "../../store/feature-usage.store";
import { useNotifications } from "../../store/notifications.store";
import { setAuthState } from "../../composables/auth";

import TermsCondition from './terms-condition.vue'
import SubscriptionModal from './subscription-modal.vue'
import ConfirmationFreePlanModal from './confirmation-free-plan-modal.vue'

const { isAuthenticated, getUser, isOnboardingComplete } = setAuthState()
const { isSubscribe } = storeToRefs(useSubscriptionPlanStore())
const { setFeatureUsage, userFeatureUsage } = useFeatureUsageStore()
const notificationStore = useNotifications()
const termsConditionModal = ref(false)
const showSubscriptionModal = ref(false)
const subscriptionCloseButton = ref(false)
const confirmationFreePlanModal = ref(false)

onMounted(async() => {
    if(isAuthenticated()) {
       if(getUser().terms_accepted_at == null) {
          termsConditionModal.value = true
       }
       // Force the subscription modal if they already accepted the terms & condition
       if(userFeatureUsage.length === 0 && getUser().terms_accepted_at != null && isOnboardingComplete()) {
          showSubscriptionModal.value = true
       }
    }
})
const handleAcceptCondition = () => {
    termsConditionModal.value = false

	if(getUser()?.options?.career_status != null){
	    showSubscriptionModal.value = true
	}
}

const handleSubscribeToPremiumPlan = async() => {
    showSubscriptionModal.value = false
    notificationStore.notify('Successfully Subscribe to Premium Plan')
    // We need to create feature usage for existing users
    // This is for when they cancel the plan
    applyFreeFeatures().then(({data}) => {
       setFeatureUsage(data)
    })
}

const handleSelectFreePlan = () => {
    termsConditionModal.value = false
    showSubscriptionModal.value = false
    confirmationFreePlanModal.value = true
}

const handleSubscribeToFreePlan = async() => {
    termsConditionModal.value = false
    showSubscriptionModal.value = false
    confirmationFreePlanModal.value = false
    
    applyFreeFeatures().then(({data}) => {
       notificationStore.notify('Subscribed to free plan')
       setFeatureUsage(data)
    })
}

const handleGoBack = () => {
    confirmationFreePlanModal.value = false

	if(getUser()?.options?.career_status != null){
        showSubscriptionModal.value = true
	}
}
</script>
